import { type PropsWithChildren, createContext, useCallback, useContext, useMemo, useRef } from 'react';
import { type ScrollView } from 'react-native';

type AuthScrollContextValue = {
  scrollRef: React.MutableRefObject<ScrollView | null>;
  scrollToTop: () => void;
};

const AuthScrollContext = createContext<AuthScrollContextValue | null>(null);

export function AuthScrollProvider({ children }: PropsWithChildren) {
  const scrollRef = useRef<ScrollView | null>(null);
  const scrollToTop = useCallback(() => {
    scrollRef.current?.scrollTo({ y: 0, animated: true });
  }, []);

  const value = useMemo(
    () => ({
      scrollRef,
      scrollToTop,
    }),
    [scrollToTop]
  );

  return <AuthScrollContext.Provider value={value}>{children}</AuthScrollContext.Provider>;
}

export function useAuthScroll(): AuthScrollContextValue {
  const context = useContext(AuthScrollContext);
  if (!context) {
    throw new Error('useAuthScroll must be used within an AuthScrollProvider');
  }
  return context;
}
